/**
 * The prompt box on the home page and the marketing hero.
 *
 * It is the one surface that sits softer than the app radius: it is the
 * largest single object on either page and carries the whole invitation to
 * start, so it reads as a card rather than a control. The frame holds the
 * inner card at `p-1`, so its radius is the inner one plus that 4px — keep
 * the pair concentric if either changes.
 *
 * The skeleton mirrors this chrome exactly; both import from here so the two
 * cannot drift while one of them is the thing a visitor sees first.
 */
export const LAUNCH_COMPOSER_FRAME_CLASSNAME =
  'mx-auto rounded-[28px] border border-border bg-muted p-1 dark:bg-background'

export const LAUNCH_COMPOSER_SURFACE_CLASSNAME =
  // The visible card is the InputGroup nested inside PromptInput, so reach it
  // rather than only the wrapper that paints nothing.
  'rounded-3xl [&_[data-slot=input-group]]:rounded-3xl'

/**
 * Identifies `/home`'s composer in the DOM — `AppChatLauncher` focuses it by
 * `[data-launch-composer="…"] textarea` after a prompt card is picked.
 *
 * It lives here, beside the chrome, rather than in `app-chat-launcher.tsx`,
 * because `/home`'s loading shell has to stamp the same id on the skeleton
 * and must not import the launcher's client module to learn it.
 */
export const CHAT_LAUNCH_COMPOSER_ID = 'app-chat-launcher'
